import {useMutation, useQueryClient} from '@tanstack/react-query';
import {consentsApi} from '../api';
import {CreateDocumentVersionDTO, ConsentDocumentVersion} from '../model';
import {useNotifications} from '../../../shared';

export const useCreateDocumentVersion = () => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  return useMutation<ConsentDocumentVersion, Error, {documentId: string; dto: CreateDocumentVersionDTO}>({
    mutationFn: ({documentId, dto}) => consentsApi.createDocumentVersion(documentId, dto),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({queryKey: ['consent-document', variables.documentId]});

      createNotification({
        title: 'Версия документа успешно добавлена',
        name: 'createDocumentVersion',
        theme: 'success',
      });
    },
    onError: () => {
      createNotification({
        title: 'Ошибка при добавлении версии документа',
        name: 'createDocumentVersionError',
        theme: 'danger',
      });
    },
  });
};
